import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabChangeLog from '../../form-fields/tab-changelog/tab-changelog';
class AddEditViewReferralTabChangeLog extends Component {
  render() {
    return (
      <div>
         <FormFieldsTabChangeLog {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
AddEditViewReferralTabChangeLog.propTypes = {
  locked: PropTypes.bool,
}
AddEditViewReferralTabChangeLog = reduxForm({
  form: 'ReferralEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AddEditViewReferralTabChangeLog);
export default AddEditViewReferralTabChangeLog;